import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576",
  code: "hy",
  messages: {
    alert: {
      close: "\u0553\u0561\u056F\u0565\u056C"
    },
    authForm: {
      hidePassword: "\u0539\u0561\u0584\u0581\u0576\u0565\u056C \u0563\u0561\u0572\u057F\u0576\u0561\u0562\u0561\u057C\u0568",
      showPassword: "\u0551\u0578\u0582\u0575\u0581 \u057F\u0561\u056C \u0563\u0561\u0572\u057F\u0576\u0561\u0562\u0561\u057C\u0568",
      submit: "\u0547\u0561\u0580\u0578\u0582\u0576\u0561\u056F\u0565\u056C"
    },
    banner: {
      close: "\u0553\u0561\u056F\u0565\u056C"
    },
    calendar: {
      nextMonth: "\u0540\u0561\u057B\u0578\u0580\u0564 \u0561\u0574\u056B\u057D",
      nextYear: "\u0540\u0561\u057B\u0578\u0580\u0564 \u057F\u0561\u0580\u056B",
      prevMonth: "\u0546\u0561\u056D\u0578\u0580\u0564 \u0561\u0574\u056B\u057D",
      prevYear: "\u0546\u0561\u056D\u0578\u0580\u0564 \u057F\u0561\u0580\u056B"
    },
    carousel: {
      dots: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0581\u0578\u0582\u0581\u0561\u0564\u0580\u0565\u056C\u0578\u0582 \u057D\u056C\u0561\u0575\u0564\u0568",
      goto: "\u0531\u0576\u0581\u0576\u0565\u056C {slide}-\u056B\u0576",
      next: "\u0531\u057C\u0561\u057B",
      prev: "\u0540\u0565\u057F"
    },
    chatPrompt: {
      placeholder: "\u0547\u0561\u0580\u0578\u0582\u0576\u0561\u056F\u0565\u056C"
    },
    chatPromptSubmit: {
      label: "\u0547\u0561\u0580\u0578\u0582\u0576\u0561\u056F\u0565\u056C"
    },
    colorMode: {
      dark: "\u0544\u0578\u0582\u0563",
      light: "\u053C\u0578\u0582\u057D\u0561\u057E\u0578\u0580",
      switchToDark: "\u0531\u0576\u0581\u0576\u0565\u056C \u0574\u0578\u0582\u0563 \u057C\u0565\u056A\u056B\u0574\u056B",
      switchToLight: "\u0531\u0576\u0581\u0576\u0565\u056C \u056C\u0578\u0582\u057D\u0561\u057E\u0578\u0580 \u057C\u0565\u056A\u056B\u0574\u056B",
      system: "\u0540\u0561\u0574\u0561\u056F\u0561\u0580\u0563\u0561\u0575\u056B\u0576"
    },
    commandPalette: {
      back: "\u0540\u0565\u057F",
      close: "\u0553\u0561\u056F\u0565\u056C",
      noData: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
      noMatch: "\u0540\u0561\u0574\u0568\u0576\u056F\u0576\u0578\u0582\u0574\u0576\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C",
      placeholder: "\u0544\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u0584 \u0570\u0580\u0561\u0574\u0561\u0576 \u056F\u0561\u0574 \u0578\u0580\u0578\u0576\u0565\u0584..."
    },
    contentSearch: {
      links: "\u0540\u0572\u0578\u0582\u0574\u0576\u0565\u0580",
      theme: "\u0539\u0565\u0574\u0561"
    },
    contentSearchButton: {
      label: "\u0548\u0580\u0578\u0576\u0565\u056C..."
    },
    contentToc: {
      title: "\u0531\u0575\u057D \u0567\u057B\u0578\u0582\u0574"
    },
    dashboardSearch: {
      theme: "\u0539\u0565\u0574\u0561"
    },
    dashboardSearchButton: {
      label: "\u0548\u0580\u0578\u0576\u0565\u056C..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u053F\u0578\u056C\u0561\u057A\u057D\u0565\u056C \u056F\u0578\u0572\u0561\u0575\u056B\u0576 \u057E\u0561\u0570\u0561\u0576\u0561\u056F\u0568",
      expand: "\u0538\u0576\u0564\u056C\u0561\u0575\u0576\u0565\u056C \u056F\u0578\u0572\u0561\u0575\u056B\u0576 \u057E\u0561\u0570\u0561\u0576\u0561\u056F\u0568"
    },
    dashboardSidebarToggle: {
      close: "\u0553\u0561\u056F\u0565\u056C \u056F\u0578\u0572\u0561\u0575\u056B\u0576 \u057E\u0561\u0570\u0561\u0576\u0561\u056F\u0568",
      open: "\u0532\u0561\u0581\u0565\u056C \u056F\u0578\u0572\u0561\u0575\u056B\u0576 \u057E\u0561\u0570\u0561\u0576\u0561\u056F\u0568"
    },
    error: {
      clear: "\u054E\u0565\u0580\u0561\u0564\u0561\u057C\u0576\u0561\u056C \u0563\u056C\u056D\u0561\u057E\u0578\u0580 \u0567\u057B"
    },
    fileUpload: {
      removeFile: "\u054B\u0576\u057B\u0565\u056C {filename}"
    },
    header: {
      close: "\u0553\u0561\u056F\u0565\u056C \u0568\u0576\u057F\u0580\u0561\u0581\u0561\u0576\u056F\u0568",
      open: "\u0532\u0561\u0581\u0565\u056C \u0568\u0576\u057F\u0580\u0561\u0581\u0561\u0576\u056F\u0568"
    },
    inputMenu: {
      create: '\u054D\u057F\u0565\u0572\u056E\u0565\u056C "{label}"',
      noData: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
      noMatch: "\u0540\u0561\u0574\u0568\u0576\u056F\u0576\u0578\u0582\u0574\u0576\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C"
    },
    inputNumber: {
      decrement: "\u054A\u0561\u056F\u0561\u057D\u0565\u0581\u0576\u0565\u056C",
      increment: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C"
    },
    modal: {
      close: "\u0553\u0561\u056F\u0565\u056C"
    },
    pricingTable: {
      caption: "\u0533\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0570\u0561\u0574\u0565\u0574\u0561\u057F\u0578\u0582\u0569\u0575\u0578\u0582\u0576"
    },
    prose: {
      codeCollapse: {
        closeText: "\u053F\u0578\u056C\u0561\u057A\u057D\u0565\u056C",
        name: "\u056F\u0578\u0564",
        openText: "\u0538\u0576\u0564\u056C\u0561\u0575\u0576\u0565\u056C"
      },
      collapsible: {
        closeText: "\u0539\u0561\u0584\u0581\u0576\u0565\u056C",
        name: "\u0570\u0561\u057F\u056F\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        openText: "\u0551\u0578\u0582\u0575\u0581 \u057F\u0561\u056C"
      },
      pre: {
        copy: "\u054A\u0561\u057F\u0573\u0565\u0576\u0565\u056C \u056F\u0578\u0564\u0568 \u057D\u0565\u0572\u0574\u0561\u057F\u0561\u056D\u057F\u0561\u056F\u056B\u0576"
      }
    },
    selectMenu: {
      create: '\u054D\u057F\u0565\u0572\u056E\u0565\u056C "{label}"',
      noData: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
      noMatch: "\u0540\u0561\u0574\u0568\u0576\u056F\u0576\u0578\u0582\u0574\u0576\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C",
      search: "\u0548\u0580\u0578\u0576\u0578\u0582\u0574..."
    },
    slideover: {
      close: "\u0553\u0561\u056F\u0565\u056C"
    },
    table: {
      noData: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576"
    },
    toast: {
      close: "\u0553\u0561\u056F\u0565\u056C"
    }
  }
});
